import type { ReactNode } from "react";

type JourneyPairProps = {
  ariaLabel?: string;
  children: ReactNode;
};

export function JourneyPair({ ariaLabel, children }: JourneyPairProps) {
  return (
    <section className="section journey-section" aria-label={ariaLabel}>
      <div className="journey-pair">{children}</div>
    </section>
  );
}
